/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## See build-api-client.ts for more details                  ##
 * ---------------------------------------------------------------
 */
import {
  EntityId,
  StorageFileMetadata,
  StorageUploadKind,
  StorageUploadURL,
} from "./data-contracts";

/**
 * @description Generate a pre-signed URL that can be used to upload a file to storage
 * @tags storage
 * @name GenerateStorageUploadUrl
 * @summary Create a signed URL to upload a file
 * @request POST:/orgs/{organizationId}/storage/upload
 * @secure
 */

// @ts-ignore
export const generateStorageUploadURL: {
  route: string;
  method: "post";
  deprecated:
    | false
    | {
        errorRate: number;
        sunset?: string | undefined;
        message?: string | undefined;
      };
  streaming: false;
  criticalityLevel: "low";
  tags: string[];
  gateway: {
    cache: {};
    edge: { mode: "none"; data: readonly []; rollout: null };
    rpc: null;
  };
  RequestParams: {
    /** The unique id of the organization */
    organizationId: EntityId;
  };
  RequestQuery: {};
  RequestBody: {
    file: StorageFileMetadata;
    kind: StorageUploadKind;
  };
  RequestHeaders: {};
  ResponseBody: StorageUploadURL;
  ResponseStatusCode: 201 | 400;
} = {
  route: "/orgs/{organizationId}/storage/upload",
  method: "post",
  streaming: false,
  tags: ["storage"],
  gateway: {
    cache: {},
    edge: { mode: "none", data: [], rollout: null },
    rpc: null,
  },
  criticalityLevel: "low",
  deprecated: false,
};
